import { render, staticRenderFns } from "./CustomProGroupLayout.vue?vue&type=template&id=0762bf8c&scoped=true"
import script from "./CustomProGroupLayout.vue?vue&type=script&lang=js"
export * from "./CustomProGroupLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomProGroupLayout.vue?vue&type=style&index=0&id=0762bf8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0762bf8c",
  null
  
)

export default component.exports